import { nsModel } from "../../../../../lib/namespace";

export const bankNS = nsModel("bank");
